import Anchor, { AnchorRef } from './Anchor';

export { type AnchorRef };

export default Anchor;
